export const options: number[] = [
    10,25,50,100
]
export const defaultCount: number = 50
